export const connection = () => {
    return {
        id: null,
        label: null,
        ip: null
    };
};

export default {
    connections: {data: []},
    connection: connection(),
    modal: {show: false},
    test_result: null,
    testing_connection: false
};
